export default __webpack_public_path__ + "cad2f1300a8752823df819dbd0a9ab44.png";